export default "__VITE_ASSET__CXgtpl$k__"